import type { Epic } from '../../../../../api/tasks-client/task-client.type';
import { showEpicRelatedTasks } from '../../../../../store/strategy-store/strategy-store.actions';
import { useCostEpics } from '../cost-tab.hooks';
import { SideSectionOther } from './side-section-other';

export const SideSectionOtherEpics = () => {
  return (
    <SideSectionOther<Epic>
      useData={useCostEpics}
      dataKey="otherEpicsData"
      showRelatedTasks={showEpicRelatedTasks}
      getDisplayName={(epic) => epic.title}
      getTitle={(epic) => epic.name}
      getItemId={(epic) => epic.id}
      paramKey="epic"
    />
  );
};
